export const primary = {
  50: '#BFE4FA',
  100: '#99D3F7',
  200: '#73C3F4',
  300: '#4DB2F1',
  400: '#26A2EE',
  500: '#0091EB',
  600: '#007BC8',
  700: '#0066A5',
  800: '#005081',
  900: '#003A5E',
  light: '#73C3F4',
  dark: '#0066A5',
  main: '#0091EB',
};

export const secondary = {
  50: '#D1E1EF',
  100: '#B5CFE5',
  200: '#99BCDC',
  300: '#7DAAD2',
  400: '#6198C9',
  A400: '#6198C9',
  500: '#4586BF',
  600: '#3B72A2',
  700: '#305E86',
  800: '#264A69',
  900: '#1C364C',
  light: '#99BCDC',
  main: '#4586BF',
  dark: '#305E86',
};

export const complementary = {
  50: '#F6E4CF',
  100: '#F0D4B1',
  200: '#EAC494',
  300: '#E4B377',
  400: '#DFA35A',
  A400: '#DFA35A',
  500: '#D9933D',
  600: '#B87D34',
  700: '#98672B',
  800: '#775122',
  900: '#573B18',
  light: '#EAC494',
  main: '#D9933D',
  dark: '#98672B',
};

export const success = {
  50: '#DCF6FC',
  100: '#C7F1FA',
  200: '#B1EBF8',
  300: '#9CE6F6',
  400: '#87E0F4',
  500: '#72DBF2',
  600: '#61BACE',
  700: '#5099A9',
  800: '#3F7885',
  900: '#2E5861',
  light: '#B1EBF8',
  main: '#72DBF2',
  dark: '#5099A9',
};

export const danger = {
  50: '#FDBFD5',
  100: '#FC99BC',
  200: '#FB73A3',
  300: '#FA4D8A',
  400: '#F92671',
  A400: '#F92671',
  500: '#F80058',
  600: '#D3004B',
  700: '#AE003E',
  800: '#880030',
  900: '#630023',
  light: '#FB73A3',
  main: '#F80058',
  dark: '#AE003E',
};

export const grey = {
  50: '#F6F6F6',
  100: '#F4F4F4',
  200: '#F2F2F2',
  300: '#CECECE',
  400: '#A9A9A9',
  500: '#858585',
  600: '#616161',
  700: '#3D3D3D',
  800: '#181818',
  900: '#020202',
  light: '#F2F2F2',
  main: '#858585',
  dark: '#3D3D3D',
};

export const blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  light: '#b0bec5',
  main: '#607d8b',
  dark: '#455a64',
};
